﻿export default class DocumentDomGenerator {
	createRootDiv() {
		const div = document.createElement("div");
		div.className = "component-resourcesBlock resources-block";

		return div;
	}

	createHeader(headerType, value) {
		const header = document.createElement(headerType);

		header.className = "resources-block-title";
		header.innerHTML = value;

		return header;
	}

	createDescription(documentGroup) {
		const header = document.createElement("div");

		header.className = "document-description";
		header.innerHTML = documentGroup.description;

		return header;
	}

	createMetaDataElement(documentGroup) {
		const metaDataDiv = document.createElement("div");
		metaDataDiv.className = "metadata";

		documentGroup.groupMetaData.forEach((metaData) => {
			const metaDiv = document.createElement("div");

			if (metaData.showText) {
				const textDiv = document.createElement("strong");
				textDiv.innerHTML = metaData.text;
				metaDiv.appendChild(textDiv);
			}

			const valueDiv = document.createElement("span");
			valueDiv.innerHTML = metaData.value;
			metaDiv.appendChild(valueDiv);

			metaDataDiv.appendChild(metaDiv);
		});

		return metaDataDiv;
	}

	createDocumentsElement(documentGroup) {
		const documentsDiv = document.createElement("div");
		const ul = document.createElement("ul");

		documentsDiv.className = "document-group";
		documentsDiv.id = documentGroup.documentGroupId;

		documentsDiv.appendChild(ul);

		return documentsDiv;
	}

	createDocumentLinks(documents) {
		const links = [];

		documents.forEach((documentLink) => {
			const li = document.createElement("li");
			const fileName = document.createElement("div");
			fileName.classList.add("filename");
			li.appendChild(fileName);

			const link = document.createElement("a");
			link.target = "_blank";
			link.title = documentLink.name;
			link.href = documentLink.url;
			link.classList.add("a-link");

			const linkText = document.createTextNode(documentLink.name);

			link.appendChild(linkText);
			fileName.appendChild(link);

			links.push(li);
		});

		return links;
	}
}
